import MyHeadTitle from './headTitle.vue';

MyHeadTitle.install = function(Vue){
  Vue.component('MyHeadTitle', MyHeadTitle);
};

export default MyHeadTitle;